import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MdrSecurityTelemetryExclusionsGridController } from '../controller/MdrSecurityTelemetryExclusionsGridController';

export class MdrSecurityTelemetryExclusionsGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MdrSecurityTelemetryExclusionsGridController,
    });
  }
}
